import { request } from '../http';

const patientsService = {
    get: () => {
        return request.get('/patient');
    },
    getById: (id) => {
        return request.get(`/patient/${id}`);
    },
    getByGroup: (id) => {
        return request.get(`/patient/group/${id}`);
    },
    getAssigned: () => {
        return request.get('/patient/assigned');
    },
    getEvolutions: (id) => {
        return request.get(`/patient/${id}/evolutions`);
    },
    postEvolution: (id, body) => {
        return request.post(`/patient/${id}/evolutions`, body);
    },
    patchEvolution: (patientId, evolutionId, body) => {
        return request.patch(`/patient/${patientId}/evolutions/${evolutionId}`, body);
    },
    deleteEvolution: (patientId, evolutionId) => {
        return request.delete(`/patient/${patientId}/evolutions/${evolutionId}`);
    },
    post: (body) => {
        return request.post('/patient', body);
    },
    patch: (body, id) => {
        return request.patch(`/patient/${id}`, body);
    },
    patchStatus: (body, id) => {
        return request.post(`/patient/${id}`, body);
    }
};

export {
    patientsService
};
